/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_SectionInputs */

const cs_property_legal_section = /** @type {(inputs: Property_Legal_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právní dokumenty`)
};

const en_property_legal_section = /** @type {(inputs: Property_Legal_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal documents`)
};

/**
* | output |
* | --- |
* | "Legal documents" |
*
* @param {Property_Legal_SectionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_section = /** @type {((inputs?: Property_Legal_SectionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_SectionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_section(inputs)
	return cs_property_legal_section(inputs)
});